import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getIsOnDemand, getRawConfigOption } from "~/store/selectors/selector.configOptions";
import { getInstanceId } from "~/store/selectors/selector.instance";
import { getLanguageById } from "~/store/selectors/selector.languages";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { param } from "~/utils/url_helper";
import { LinkContextProvider } from "./context/index.jsx";

export const LinkProvider = ({ children }) => {
  const isOnDemand = useSelector((state) => getIsOnDemand(state));
  const rawOnDemandSettings = useSelector((state) => getRawConfigOption(state, "on_demand_settings"));
  const instanceId = useSelector(getInstanceId);
  const loggedUser = useSelector(getLoggedUser);
  const language = useSelector((state) => getLanguageById(state, loggedUser.language_id));
  const languageName = language?.name || "";

  const onDemandSettings = useMemo(() => {
    return rawOnDemandSettings?.toJS() || {};
  }, [rawOnDemandSettings]);

  const liveSupportQueryData = useMemo(() => {
    if (isOnDemand) {
      return param({
        account_id: instanceId,
        full_name: loggedUser.display_name,
        email: loggedUser.email,
        system_role: loggedUser.class,
        language: languageName,
        browser: window.navigator.userAgent,
        account_status: onDemandSettings.account_status,
        is_paid: onDemandSettings.is_paid,
        billing_period: onDemandSettings.billing_period,
        plan: onDemandSettings.current_plan?.name,
        account_created_at: onDemandSettings.account_created_at,
        crisp: 1,
      });
    }

    return param({});
  }, [
    instanceId,
    languageName,
    loggedUser.class,
    loggedUser.display_name,
    loggedUser.email,
    onDemandSettings.account_created_at,
    onDemandSettings.account_status,
    onDemandSettings.billing_period,
    onDemandSettings.current_plan?.name,
    onDemandSettings.is_paid,
    isOnDemand,
  ]);

  return <LinkContextProvider value={{ liveSupportQueryData }}>{children}</LinkContextProvider>;
};

LinkProvider.propTypes = {
  children: PropTypes.node,
};
